import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

type Theme = 'light' | 'dark'

const STORAGE_KEY = 'toteat-theme'

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<Theme>('light')
  const override = ref<Theme | null>(null)

  const isDark = computed(() => (override.value ?? theme.value) === 'dark')

  function applyToDocument() {
    document.documentElement.classList.toggle('dark', isDark.value)
  }

  function setOverride(next: Theme | null) {
    override.value = next
    applyToDocument()
  }

  function setTheme(next: Theme) {
    theme.value = next
    localStorage.setItem(STORAGE_KEY, next)
    applyToDocument()
  }

  function toggle() {
    setTheme(isDark.value ? 'light' : 'dark')
  }

  function initTheme() {
    theme.value = localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
    applyToDocument()
  }

  return { theme, isDark, setTheme, toggle, initTheme, setOverride }
})
